import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ActiveBookings, HistoryBookings, BookingDetail } from '../screens/bookings';

const BookingsRouter: FC = () => (
    <Routes>
        <Route path="actives" element={<ActiveBookings />} />
        <Route path="history" element={<HistoryBookings />} />
        <Route path=":id" element={<BookingDetail />} />
    </Routes>
);

export { BookingsRouter };
